import { render, staticRenderFns } from "./recordPopup.vue?vue&type=template&id=31f3e0cd"
import script from "./recordPopup.vue?vue&type=script&lang=js"
export * from "./recordPopup.vue?vue&type=script&lang=js"
import style0 from "./recordPopup.vue?vue&type=style&index=0&id=31f3e0cd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports